module.exports = __webpack_public_path__ + "img/join2-3.8baa4e53.jpg";